import { IntlShape } from "react-intl";

const GLOBAL_YEAR_INTL_ID = "global.year";
const GLOBAL_MONTH_INTL_ID = "global.month";

export function priceDisplayFormat(
  intl: IntlShape,
  price: number,
  isYearly: boolean,
  currency?: string,
  unitMessage?: string,
): string {
  const fixedPrice = parseFloat((isYearly ? price : price / 12).toFixed(2));
  const formattedPrice = intl.formatNumber(fixedPrice, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
  const unitMessageText = unitMessage ? ` / ${unitMessage}` : "";
  const periodMessageId = isYearly ? GLOBAL_YEAR_INTL_ID : GLOBAL_MONTH_INTL_ID;
  const periodMessage = intl.formatMessage({ id: periodMessageId });

  return `${currency} ${formattedPrice}${unitMessageText} / ${periodMessage}`;
}
